<template>
  <div>
    <div class="display-flex w-100 justify-content-between">
      <h2 class="mb-0">Noty obciążeniowe</h2>
      <DebitNoteChips
        :searched="Object.assign({}, searched)"
        @updateData="changeSearchData"
        @toggleSearch="setToggle"
      ></DebitNoteChips>
    </div>

    <transition name="fade" mode="out-in">
      <div class="display-flex w-100 justify-content-end search-form" v-if="showSearch">
        <DebitNotesSearch
          :paymentMethods="paymentMethods"
          :propsSearchData="searchData"
          @search="search"
        ></DebitNotesSearch>
      </div>
    </transition>

    <div class="mt-4 content-wrapper p-3">
      <DebitNoteTable
        :loading="loading"
        :totalItems="getTotalNotes"
        :currentPage="tablePage"
        @paginationChange="onPaginationChange"
        @printPDF="printPDF"
        @downloadPDF="downloadPDF"
        @deleteNote="prepareDelete"
      ></DebitNoteTable>
    </div>

    <div class="display-flex justify-content-end mt-2">
      <v-btn class="mr-0" :loading="listPdfLoading" @click="downloadListPDF">
        Pobierz zestawienie PDF
      </v-btn>
    </div>

    <DeleteModal
      :open="deleteOpen"
      deleteText="Czy na pewno chcesz usunąć notę obciążeniową?"
      @close="deleteOpen = false"
      @accept="confirmDelete"
    ></DeleteModal>

    <router-view @printPDF="printPDF" @downloadPDF="downloadPDF"></router-view>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import FileSaver from 'file-saver';
  import printJS from 'print-js';
  import { clearEmptyFields } from '../helpers/clearEmptyFields';
  import { getPDF } from '../services/api.service';
  import DeleteModal from '../components/Globals/ModalDelete.vue';
  import DebitNoteChips from '@/components/DebitNotes/DebitNoteChips.vue';
  import DebitNotesSearch from '@/components/DebitNotes/DebitNotesSearch.vue';
  import DebitNoteTable from '@/components/DebitNotes/DebitNoteTable.vue';

  export default {
    name: 'DebitNotes',
    components: {
      DeleteModal,
      DebitNoteChips,
      DebitNotesSearch,
      DebitNoteTable,
    },
    data() {
      return {
        showSearch: false,
        loading: true,
        listPdfLoading: false,
        tablePage: 1,
        lastPagination: null,
        searchObj: {},
        searchData: {},
        searched: {},
        deleteOpen: false,
        noteIdToDelete: null,
        paymentMethods: [],
      };
    },
    computed: {
      ...mapGetters('DebitNoteStore', ['getTotalNotes']),
    },
    watch: {
      $route(from) {
        if (from.name === 'DebitNotes') {
          this.fetchNotes(this.buildFetchParams(this.searchObj, this.lastPagination));
        }
      },
    },
    beforeMount() {
      this.fetchNotes(this.buildFetchParams({}, null))
        .then(() => { this.loading = false; });
      this.fetchMeta({})
        .then((meta) => {
          this.paymentMethods = meta.payment_methods || [];
        });
    },
    methods: {
      ...mapActions('DebitNoteStore', ['fetchNotes', 'fetchMeta', 'removeNote']),
      setToggle(toggle) {
        this.showSearch = toggle;
      },
      buildFetchParams(searchObj, pagination) {
        const params = Object.assign({}, searchObj);
        params.page = (pagination && pagination.page) || 1;
        params.per_page = (pagination && pagination.rowsPerPage) || 25;
        if (pagination && pagination.sortBy) {
          params.sort_by = pagination.sortBy;
          params.sort_dir = pagination.descending ? 'desc' : 'asc';
        }
        return params;
      },
      onPaginationChange(pagination) {
        this.lastPagination = pagination;
        this.fetchNotes(this.buildFetchParams(this.searchObj, pagination));
      },
      search(prepare, data) {
        if (data !== undefined) this.searchData = data;
        if (prepare) this.searched = Object.assign({}, this.searchData);
        const searchObj = clearEmptyFields(Object.assign({}, this.searchData));
        this.searchObj = searchObj;
        this.tablePage = 1;
        this.lastPagination = null;
        this.fetchNotes(this.buildFetchParams(searchObj, null));
      },
      changeSearchData(element) {
        this.searched[element] = null;
        this.searchData[element] = null;
        this.search(false);
      },
      prepareDelete(id) {
        this.noteIdToDelete = id;
        this.deleteOpen = true;
      },
      confirmDelete() {
        this.deleteOpen = false;
        this.removeNote({ id: this.noteIdToDelete, searchObj: this.buildFetchParams(this.searchObj, this.lastPagination) });
      },
      async printPDF(id) {
        const response = await getPDF(`/debit-notes/${id}/pdf`);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        printJS(URL.createObjectURL(blob));
      },
      async downloadPDF(id, number) {
        const response = await getPDF(`/debit-notes/${id}/pdf`);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        FileSaver.saveAs(blob, `Nota-${number || id}.pdf`);
      },
      async downloadListPDF() {
        this.listPdfLoading = true;
        try {
          const params = [];
          if (this.searchObj.issued_from) params.push(`issued_from=${this.searchObj.issued_from}`);
          if (this.searchObj.issued_to) params.push(`issued_to=${this.searchObj.issued_to}`);
          if (this.searchObj.payment_method) params.push(`payment_method=${this.searchObj.payment_method}`);
          const query = params.length ? `?${params.join('&')}` : '';
          const response = await getPDF(`/debit-notes-list/pdf${query}`);
          const blob = new Blob([response.data], { type: 'application/pdf' });
          FileSaver.saveAs(blob, `Noty-zestawienie-${this.moment(new Date()).format('YYYY-MM-DD')}.pdf`);
        } catch (e) {
          console.log(e);
        } finally {
          this.listPdfLoading = false;
        }
      },
    },
  };
</script>
